export default "__VITE_ASSET__Dcw2JX5b__"